import React, { useState } from 'react'
import FilterSection from './FilterSection'
import StatsList from './StatsList'

const Ranking = () => {
    const [filters, setFilters] = useState({
        country: '',
        state: '',
        game: '',
        search: '',
        sort: ''
    });

    const handleFilterChange = (newFilters) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            ...newFilters
        }));
    };
    return (
        <div>
            {/* <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-one" role="tabpanel" aria-labelledby="pills-one-tab" tabIndex={0}> */}
            <section className="stats-section spacer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <FilterSection onFilterChange={handleFilterChange} />
                            <StatsList filters={filters} />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Ranking